import { translate, translateFormatter } from '@/domains/core/localization/translate';
const {
  pageTitle,
  profile
} = translate({
  "pageTitle": "Wishlists",
  "profile": "My profile"
});
const productCountItems = translateFormatter<{
  productCount: number;
}>("{productCount, plural,\n=0 {Empty list}\n=1 {{productCount} product}\nother {{productCount} products}\n}", undefined, undefined, "en");
export { pageTitle, productCountItems, profile };